import { React, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule.js';
import AccountInput from '../../../Component/AccountComponent/AccountInput.js';

const SearchPassword = () => {
  const [ownerClickCount, setOwnerClickCount] = useState(0);
  const [emailClickCount, setEmailClickCount] = useState(0);
  const [idClickCount, setIdClickCount] = useState(0);
  const [invalidEmail, setInvalidEmail] = useState(true);
  const [sendExplanation, setSendExplanation] = useState('비밀번호 변경 URL이 해당 이메일로 전송되었습니다.');
  const [planationText, setPlanationText] = useState('필수항목을 입력해주세요');

  const OwnerRef = useRef();
  const EmailRef = useRef();
  const IdRef = useRef();

  const OwnerPlanationRef = useRef();
  const EmailPlanationRef = useRef();
  const IdPlanationRef = useRef();
  const TotalPlanationRef = useRef();

  useEffect(() => {
    if (invalidEmail) setPlanationText('필수항목을 입력해주세요');
    else setPlanationText('올바른 이메일 형식이 아닙니다');
  }, [invalidEmail])

  useEffect(() => {
		if (ownerClickCount === 0 && emailClickCount === 0 && idClickCount === 0) return;

		if (OwnerRef.current.getValue() === '' && ownerClickCount > 0) OwnerPlanationRef.current.style.opacity = 1;
    else OwnerPlanationRef.current.style.opacity = 0;

		if (EmailRef.current.getValue() === '' && emailClickCount > 0) EmailPlanationRef.current.style.opacity = 1;
		else EmailPlanationRef.current.style.opacity = 0;

    if (IdRef.current.getValue() === '' && idClickCount > 0) IdPlanationRef.current.style.opacity = 1;
		else IdPlanationRef.current.style.opacity = 0;

	}, [ownerClickCount, emailClickCount, idClickCount])

  // email형식 확인 정규식
	function isEmail(asValue) {
		var regExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,6}$/i;

		return regExp.test(asValue);
	}

  // Input 컴포넌트 클릭시
  function clickCountFn(className, clickCount) {
    if (className === 'OwnerInput') setOwnerClickCount(clickCount);
    else if (className === 'EmailInput') setEmailClickCount(clickCount);
    else if (className === 'IdInput') setIdClickCount(clickCount);
  }

  // 이메일 전송 클릭시
  function sendingButtonClick() {	
    var ownerName = OwnerRef.current.getValue();
    var email = EmailRef.current.getValue();
    var userId = IdRef.current.getValue();
    var invalidCount = 0;

    // console.log("?? " + email)
		if (ownerName === '') { 
			OwnerRef.current.plusClickCount();
			OwnerRef.current.setDefaultPlaceholder('반드시 성함을 입력해주세요');
			OwnerPlanationRef.current.style.opacity = 1;
			
			invalidCount += 1;
		} 

		if (email === '') { 
			EmailRef.current.plusClickCount();
			EmailRef.current.setDefaultPlaceholder('가입시 입력하신 이메일 주소를 적어주세요');
			EmailPlanationRef.current.style.opacity = 1;
			
			invalidCount += 1;
		} 
    else if (!isEmail(email)) {
      setInvalidEmail(false);
			EmailRef.current.setDefaultPlaceholder('가입시 입력하신 이메일 주소를 적어주세요');
			EmailPlanationRef.current.style.opacity = 1;
			
			invalidCount += 1;
    }

    if (userId === '') {
			IdRef.current.plusClickCount();
			IdRef.current.setDefaultPlaceholder('사용중인 아이디를 입력해주세요');
			IdPlanationRef.current.style.opacity = 1;
    }

    if (invalidCount > 0) return;

    // const fetchModule = new FetchModule();
		// (
		// 	async () => {
		// 		const responseData = await fetchModule.postData('identifier/asp/identified/' + ownerName + '/' + email + '/' + userId, 'POST');
				 
		// 		if (responseData.status === 200) setSendExplanation('해당 주소로 이메일이 전송되었습니다');
		// 		else setSendExplanation('올바르지 않은 정보입니다.');
		// 	}
		// )();

    var requestData = {
      ownerName: ownerName,
      email: email,
      userId: userId
    }

    const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.postData('identifier/send', 'POST', requestData);
				 
				if (responseData.status === 200) setSendExplanation('해당 주소로 이메일이 전송되었습니다');
				else setSendExplanation('올바르지 않은 정보입니다.');
			}
		)();
    
    TotalPlanationRef.current.style.opacity = 1;
  }

  return (
    <TopLevelWrapper>
      <InfoBox>
        <InfoWrapper>
          <Title>비밀번호 찾기</Title>
          <InputInfo>관리자 성함</InputInfo>
          <AccountInput ref={OwnerRef} className='OwnerInput' placeholder='반드시 성함을 입력해주세요' type='text' clickCountFn={clickCountFn} />
          <AccountExplanation ref={OwnerPlanationRef}>필수항목을 입력해주세요</AccountExplanation>
          <InputInfo>이메일</InputInfo>
          <AccountInput ref={EmailRef} className='EmailInput' placeholder='가입시 입력하신 이메일 주소를 적어주세요' type='text' clickCountFn={clickCountFn} />
          <AccountExplanation ref={EmailPlanationRef}>{planationText}</AccountExplanation>
          <InputInfo>아이디</InputInfo>
          <AccountInput ref={IdRef} className='IdInput' placeholder='사용중인 아이디를 입력해주세요' type='text' clickCountFn={clickCountFn} />
          <AccountExplanation ref={IdPlanationRef}>필수항목을 입력해주세요</AccountExplanation>
          <TotalExplanationWrapper>
            <TotalExplanation ref={TotalPlanationRef}>{sendExplanation}</TotalExplanation>
          </TotalExplanationWrapper>
          <SendingButton onClick={sendingButtonClick}>
            <SendingButtonText>이메일로 비밀번호 변경 URL 전송</SendingButtonText>
          </SendingButton>

        </InfoWrapper>
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default SearchPassword;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;

  width: 582px;
  // width: max(351px, 30.3125vw);
  height: 595px;
  // height: max(449px, 28.90625vw);

  border-radius: 50px;
  // border-radius: max(30px, 2.604166666666667vw);
  background-color: #FFFFFF;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);

  transition: all 0.3s ease-in-out;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 468px;
  // width: max(271px, 24.375vw);

  height: 100%;
  padding: 50px 0;

  // margin: 54px 0 0 0;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 24px;
  // font-size: max(18px, 1.25vw);

  color: #000000;

  // margin: 0 0 38px 0;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 38px;
  margin-left: 0px;
  
  transition: all 0.3s ease-in-out;
`;

const InputInfo = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 16px;
  // font-size: max(12px, 0.7291666666666667vw);

  color: #000000;

  margin: 19px 0 0 0;
  // margin-top: max(11px, 0.9895833333333333vw);
  // margin-right: 0px;
  // margin-bottom: 0px;
  // margin-left: 0px;
  
  transition: all 0.3s ease-in-out;
`;

const AccountExplanation = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
  // font-size: max(12px, 0.625vw);
	// line-height: 17.38px;

	color: #FF3131;

	margin: 4px 0 0 0;
	opacity: 0;

  transition: all 0.3s ease-in-out;
`;

const SendingButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 468px;
  // width: max(271px, 24.375vw);
  height: 46px;
  // height: max(28px, 2.395833333333333vw);

  margin-top: 0;
  // margin-top: max(13px, 2.083333333333333vw);

  background-color: #FF8B48;
  border-radius: 23px;

  transition: all 0.3s ease-in-out;

	&:hover {
		cursor: pointer;
		background-color: #FF7322;
	}
`;

const SendingButtonText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;
  // font-size: max(12px, 0.7291666666666667vw);

  color: #FFFFFF;
  margin: 10px 0 10px 0;

  &:hover {
    cursor: pointer;
  }
`;

const TotalExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  flex: 1;
`;

const TotalExplanation = styled.p`
	font-family: NotoSansKR-Regular;
	// font-size: max(12px, 0.625vw);
  font-size: 12px;
	// line-height: 17.38px;

	color: #FF8B48;

	margin: 0;
  // margin-top: max(8px, 1.041666666666667vw);
  // margin-right: 0px;
  // margin-bottom: 0px;
  // margin-left: 0px;

	opacity: 0;
  transition: all 0.3s ease-in-out;
`;
